import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export const GroupedMenuBody = (props) => {
	const {
		className,
		children
	} = props;

	return (
		<div className={classNames(className, 'ads-grouped-menu-body')}>{children}</div>
	);
}

GroupedMenuBody.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

GroupedMenuBody.defaultProps = {
	className: '',
};
